import { render, staticRenderFns } from "./CacheView.vue?vue&type=template&id=c4d96b22"
import script from "./CacheView.vue?vue&type=script&lang=js"
export * from "./CacheView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports